import api from './api';

export const loyaltyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveDiscounts: builder.mutation({
        query: (body) => ({
            method: 'post',
            url: `basket/savediscounts`,
            body
        })
    }),
    clearDiscounts: builder.mutation({
      query: (body) => ({
          method: 'post',
          url: `basket/cleardiscounts`,
          body
      })
  })
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSaveDiscountsMutation,
  useClearDiscountsMutation
} = loyaltyApi;